import React, {useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';
import UserContext from "./UserContext";
import { useHistory } from 'react-router-dom';
import LogoCatbears from 'components/LogoCatbears/LogoCatbears';
import ButtonCircle from 'components/ButtonCircle/ButtonCircle';
import RegisterMachine from 'components/RegisterMachine/RegisterMachine';
import "./LoginPage.scss"

const RegisterToCatbears = ({onLogin, onClose, shouldAllowSwitchToRegister, getIsRegisterMode=false}) => {
  const {user} = useContext(UserContext);
  const history = useHistory();
  const {t} = useTranslation();
  const [currentMode, setCurrentMode] = useState('register');

  const onContinue = () => {
    history.goBack();
  }

  return (
    <>
        <div className={"Onboarding-content Onboarding-container-no-footer login-page-container hideScrollbar"}>
            <ButtonCircle classes={'ButtonCircle-back ButtonCircle-50px login-page-back'} onClick={() => history.goBack()} />
            <LogoCatbears 
                isCentered 
                isTapToLandingPage
                isFixed={false}
            />
            <div className="login-page-form-container">
              <div className="login-page-title">
                {currentMode === 'register' && t('loginFlow.registerToCatbears_title')}
                {currentMode === 'login' && t('loginFlow.loginToCatbears_title')}
                {currentMode === 'forgot' && t('loginFlow.forgotPasswordTitle')}
              </div>
              <div className="login-page-subtitle">
                {currentMode === 'register' && t('loginFlow.registerToCatbears_subtitle')}
                {currentMode === 'login' && t('loginFlow.loginToCatbears_subtitle')}
                {currentMode === 'forgot' && t('loginFlow.forgotPasswordSubtitle')}
              </div>
              <RegisterMachine 
                onSuccess={onContinue}
                initialMode="register"
                onModeChange={setCurrentMode}
                isBrightMode={true}
              />
            </div>
        <div className='Room'></div>
      </div>
    </>
  )
}


export default RegisterToCatbears;